import { StyleSheet } from "react-native"
import { baseColors, basePadding, baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white,
        paddingBottom: 10
    },
    content: {
        paddingHorizontal: basePadding.paddingHorizontal,
        paddingVertical: basePadding.paddingVertical
    },
    header: { marginBottom: 20 },
    title: {
        fontSize: 22
    },
    subTitle: {
        fontSize: 16
    },
    checkBoxLabel: { flex: 1, marginLeft: 7, color: baseColors.orange.primary },
    checkBoxLabelGreen: { flex: 1, marginLeft: 7, color: baseColors.green.primary },
    firstCheckBoxContent: { flexDirection: "row", alignItems: "center", marginBottom: 25 },
    secondCheckBoxContent: { flexDirection: "row", alignItems: "center", marginBottom: 25 },
    thirstCheckBoxContent: { flexDirection: "row", alignItems: "center", marginBottom: 25 }
})

export default styles
